import type { LogisticOperator } from '../models';

export const formatLogisticOperatorNameDisplayLabel = (
  operator: LogisticOperator
): string => {
  const name = operator.fullName?.trim() ?? '';
  if (name.length > 0) return name;
  const business = operator.businessName?.trim() ?? '';
  if (business.length > 0) return business;
  return 'Operador';
};

export const formatLogisticOperatorBusinessDisplayLabel = (
  operator: LogisticOperator
): string => {
  const business = operator.businessName?.trim() ?? '';
  if (business.length > 0) return business;
  const name = operator.fullName?.trim() ?? '';
  if (name.length > 0) return name;
  return 'Razón social';
};
